export class AddUsers{
	constructor(
		public nombre: string,
		public apellido:string,
		public email:string,
    public proyecto:number,
    public id:number
	){}
}

export class EditUsers{
constructor(
public nombre: string,
public apellido: string,
public email: string,
public proyecto: number,
public id: number,
public file: File
){}
}

export class FileItem {
    public archivo: File;
    public nombreArchivo: string;
    public url: string;
    public estaSubiendo: boolean;
    public progreso: number;
    constructor( archivo: File ) {
        this.archivo = archivo;
        this.nombreArchivo = archivo.name;
        this.estaSubiendo = false;
        this.progreso = 0;
    }
}
